var backgroundImageList = [
    "./images/captain.jpg",
  
    "./images/hulk.jpg",
  
    "./images/tony.jpg",
  
    "./images/spiderman.jpg",
      
    "./images/thor.jpg ",    
  ];
  
  export default backgroundImageList;